import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ error, setError ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const [ username, setUsername ] = useState("");
  const [ password, setPassword ] = useState("");
  const [ email, setEmail ] = useState("");


  const init = () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }


  const signUp = async (e) => {
    e.preventDefault();
    if(!loading) {
      if(email.trim().length > 0) {
        
        if(isAlphanumeric(username)  && username.length > 2 && username.length <= 30) {
          if(password.length >= 6) {
            setLoading(true);
            await callGameServerApi('signup', { email, username, password }).then(async response => {
              if(response.status === 1) {
                await appContext.saveLocalUser({ userId: response.userId, userToken: response.userToken });
                appContext.refresh();
              } else {
                setLoading(false);
                setError(response.msg);
              }
            })
          } else {
            setError("Invalid password, atleast 6 characters are required");
          }
        } else {
          setError("Invalid username, minimum 2 characters and only letters, numbers, underscore and dash are allowed");
        }
        
      } else {
        setError('Invalid email');
      }
      
    }
  }



  useEffect(() => {
    if(appContext.auth) {
      //take to common area
      appContext.openHome();
    } else {
      //initialize
      init();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  return (
    <>
      <div className='FullPane' style={{ paddingBottom: "var(--topBarheight)" }}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6'>
              <h2 className='font-light text-goldish' style={{ marginTop: "calc(var(--topPaneHeight) * 0.5)" }}>Sign up</h2>
              <small className='text-muted'>Please sign up to enjoy all features of Soldrax</small>
              <h6 style={{ marginTop:"20px", marginBottom:"20px" }} className='font-light text-redish'>
                {(error) ? error: ''}
              </h6>

              <form onSubmit={(e) => signUp(e)} style={{ marginTop:"10px" }}>
                <div className='form-group'>
                  <label>Email</label>
                  <input type="text" value={email} onChange={(e) => setEmail(e.target.value.trim())} className='form-control'/>
                </div>

                <div className='form-group'>
                  <label>Username</label>
                  <input type="text" value={username} onChange={(e) => setUsername(e.target.value.trim())} maxLength={30} className='form-control'/>
                </div>

                <div className='form-group'>
                  <label>Create Password</label>
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className='form-control'/>
                </div>

                <div className='form-group text-end'>
                  <button className='btn bg-faint-black btn-rounded'>Sign Up</button>
                </div>
              </form>

              <div className='text-start font-light' style={{fontSize: "14px"}}>
                You can also <a className='font-bold text-goldish' onClick={() => appContext.navTo({ item: 'signin' })}>Sign In</a> if you have an account or <a className='font-bold text-goldish' onClick={() => appContext.navTo({ item: 'reset_pwd' })}>Reset Your Password</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
